/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  actionCMD,
  CMDReq,
} from '..';
import {
  serializeactionCMD,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendCommandBasicInPlantStatusInput {
  deviceId: string;
  action: actionCMD;
  plantId: string;
  transactionId?: string;
}
const build = (_query: DocumentNode, input: SendCommandBasicInPlantStatusInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.action !== undefined ? `$action: actionCMD = ${serializeactionCMD(input.action)}, ` : '' ) + ``+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    sendCommandBasicInPlantStatus(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' } 
      ${ input.action !== undefined ? 'action: $action,' : '' } 
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' }
    ){
      ...cmdreq
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendCommandBasicInPlantStatusMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment cmdreq on CMDReq { ... }
   */
  async execute(_query: DocumentNode, input: SendCommandBasicInPlantStatusInput): Promise<apollo.FetchResult< { sendCommandBasicInPlantStatus: Partial<CMDReq> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendCommandBasicInPlantStatus: Partial<CMDReq> }>({ mutation: build(_query, input) });
  }
}
